import React, { createContext, useReducer } from 'react';
import { 
  generateCoherentColorSet, 
  darkenHexColor as darkenColor, 
  lightenHexColor as lightenColor
} from '../utils/common/colorUtils';

// Generate initial coherent colors
const generateTreeColors = () => {
  // Generate base colors
  const trunkColor = '#7D5A4F';
  const foliageColor = '#2D6A4F';
  
  return {
    trunkColor,
    foliageColor
  };
};

// Initial colors
const initialColorState = generateTreeColors();

// Generate initial state
const initialState = {
  // Tree structure
  treeHeight: 30,
  treeThickness: 3, // Unified thickness for trunk and branches
  
  // Branch system
  enableBranches: true,
  branchStartHeight: 0.3, // Percentage of trunk height where branches start (0-1)
  branchLengthMin: 10, // Minimum length of primary branches
  branchLengthMax: 25, // Maximum length of primary branches
  branchDensity: 0.5, // How many branches per segment (0-1)
  branchRecursion: 1, // Number of recursion levels (1-3)
  
  // Foliage
  showFoliage: false, // New toggle to show/hide foliage
  foliageHeight: 20,
  foliageWidth: 24,
  foliageShape: 'round', // can be 'round', 'conical', 'blocky'
  
  // Environment
  showGround: true,
  
  // Colors
  ...initialColorState
};

// Reducer function for the TreeContext
const treeReducer = (state, action) => {
  const { field, value } = action;

  if (field === 'regenerateColors') {
    // Generate new colors
    const newColors = generateTreeColors();
    return {
      ...state,
      ...newColors
    };
  }

  // Handle other state updates
  return {
    ...state,
    [field]: value
  };
};

export const TreeContext = createContext();

export const TreeProvider = ({ children }) => {
  const [state, dispatch] = useReducer(treeReducer, initialState);
  return (
    <TreeContext.Provider value={{ state, dispatch }}>
      {children}
    </TreeContext.Provider>
  );
}; 